import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { NavLink, useRouteMatch } from "react-router-dom";
import { AthleteType } from "../../../../utilities/constants";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { AutocompleteValidator } from "../../../../utilities/validators";
import { Autocomplete } from "@material-ui/lab";
import {

  addAppointmentRequest,
  cancelAppointmentRequest,
  editAppointmentRequest,
  getDoctorAppointmentRequest,
} from "../../AppointmentApiActions";
import { getCaseByIdRequest } from "../../../Cases/CasesApiAction";
import {
  getAllDeptsRequest,
  getAvailabilityRequest,
} from "../../../Departments/DepartmentsApiActions";
import {
  getOrganisationsWithoutParamsRequest,
  getSettingRequest,
} from "../../../Organizations/OrganisationsApiActions";
import { getDoctorsRequest } from "../../../Doctors/DoctorApiActions";
import { getPatientsWithoutParamsRequest } from "../../../Athletes/PatientApiActions";
import { useStyles } from "./styles";
import ConfirmationDialog from "../../../../utilities/components/ConfirmationDialog/ConfirmationDialog";
import { getPatientCasesRequest } from "../../../Cases/CasesApiAction";
import { getUserInfo } from "../../../../utilities/storage";
import {
  APP_URLS,
  APPOINTMENT_SCHEDULE_TIME_MINUTES,
} from "../../../../utilities/constants";
import CancelAppointmentDialog from "../CancelAppointmentDialog/CancelAppointmentDialog";
import AddPatient from "../../../Athletes/components/PatientFormDialog/PatientFormDialog";
import AddCaseDialog from "../../../Cases/components/CaseFormDialog/CaseFormDialog";
import defaultUser from "../../../../assets/user.png";
import WeeklyScheduleGrid from "../WeeklyScheduleGrid/WeeklyScheduleGrid";
import SelectedDaySidebar from "../SelectedDaySidebar/SelectedDaySidebar";
import RemoveIcon from "@material-ui/icons/Delete";
import EventNoteRoundedIcon from "@material-ui/icons/EventNoteRounded";
import moment from "moment";
import AppBreadCrumb from "../../../../components/AppBreadCrumb/AppBreadCrumb";
import { clearCases } from "../../../Cases/CasesActions";
import { showSnackbar } from "../../../../utilities/UtilitiesActions";
import { getUserByIdRequest } from "../../../Users/UsersApiActions";
import { SelectValidator } from "react-material-ui-form-validator";
import MenuItem from "@material-ui/core/MenuItem";

const dayMap = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

const AppointmentForm = ({
  history,
  getAllOrgs,
  departmentData,
  getAllDoctors,
  doctors,
  getAllPatient,
  patients,
  getAllCases,
  getSingleCase,
  cases,
  addAppointment,
  editAppointment,
  cancelAppointment,
  getAllAppointments,
  appointments,
  getAllDepts,
  clearAllCases,
  getUserByIdRequest,
  availability,
  getDoctorAvailability,
  setting,
  getOrgSetting,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const formRef = useRef(null);
  const role = getUserInfo().Roles[0].name;
  const userDetails = getUserInfo();
  const match = useRouteMatch();
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState(false);
  const [openCancelAppointment, setOpenCancelAppointment] = useState(false);
  const [cancellingAppointment, setCancellingAppointment] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [gridViewMode, setGridViewMode] = useState("week");
  const [gridAnchorDate, setGridAnchorDate] = useState(() => moment());
  const [sidebarDate, setSidebarDate] = useState(() => moment());
  const [sidebarCalMonth, setSidebarCalMonth] = useState(() =>
    moment().startOf("month")
  );
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDept, setSelectedDept] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedCase, setSelectedCase] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [selectedAppointmentLink, setSelectedAppointmentLink] = useState("");
  const [selectedStartTime, setSelectedStartTime] = useState(null);
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [openCreatePatientModal, setOpenCreatePatientModal] = useState(false);
  const [openCreateCaseModal, setOpenCreateCaseModal] = useState(false);
  const [businessHours, setBusinessHours] = useState([]);
  const [slotTimeDuration, setSlotTimeDuration] = useState(null);
  const [selectedAppointmentType, setSelectedAppointmentType] =
    useState("offline");
  const [formMode, setFormMode] = useState("editable");

  const [filteredDepts, setFilteredDepts] = useState([]);

  const currentUrlPath = match.path.split(":")[0];

  const breadCrumbDataForAddAppointmentForm = [
    {
      icon: "business",
      name: "Appointments",
      path: APP_URLS.APPOINTMENTS_ADD,
    },
  ];

  const formatTime = (timeInMillis) => {
    if (!timeInMillis) return "";
    const date = new Date(timeInMillis);
    return date.toTimeString().substring(0, 5);
  };

  const handleEventClick = async (info) => {
    const selectedAppointment = appointments.find(
      (appointment) => appointment.id === parseInt(info.event.id)
    );
    if (!selectedAppointment) return;

    const now = new Date();
    const eventEnd = info.event.end || info.event.start;
    if (new Date(eventEnd) < now) {
      setFormMode("readonly");
    } else {
      setFormMode("editable");
    }

    setSelectedAppointmentId(selectedAppointment.id);
    setSelectedDept(
      departmentData?.rows?.find(
        (dept) => dept.id === selectedAppointment.TeamId
      ) || null
    );

    try {
      const patientsData = await getAllPatient(
        selectedAppointment.UserId,
        AthleteType.USER
      );

      const casesData = await getAllCases(selectedAppointment.PatientId);

      const selectedPatientData =
        patientsData?.rows?.find(
          (patient) => patient.id === selectedAppointment.PatientId
        ) || null;

      const selectedCaseData =
        casesData?.rows?.find(
          (casee) =>
            casee.PatientId === selectedAppointment.PatientId &&
            casee.id === selectedAppointment.CaseId
        ) || null;

      if (!selectedPatientData || !selectedCaseData) {
        dispatch(
          showSnackbar(
            `${!selectedCaseData ? "Cases" : "Patient"} are not available`,
            "error"
          )
        );
        return;
      }

      setSelectedPatient(selectedPatientData);
      setSelectedCase(selectedCaseData);
      setSelectedDate(selectedAppointment.appointmentDate);
      setSelectedTitle(selectedAppointment.title);
      setSelectedStartTime(selectedAppointment.startTime);
      setSelectedEndTime(selectedAppointment.endTime);
      setSelectedAppointmentLink(selectedAppointment.appointmentLink);
      setSelectedAppointmentType(selectedAppointment.appointmentType);
      setOpenForm(true);
    } catch (error) {
      console.error("Error fetching patient or case data:", error);
    }
  };

  useEffect(() => {
    if (!openForm) {
      setFormMode("editable");
    }
  }, [openForm]);

  useEffect(() => {
    if (availability && availability?.length) {
      const slotMap = {};
      availability.forEach((item) => {
        if (!item.isWorkingDay) return;

        const day = dayMap[item.dayOfWeek];
        const startTime = formatTime(item.openingTime);
        const endTime = formatTime(item.closingTime);
        const key = `${startTime}-${endTime}`;

        if (!slotMap[key]) {
          slotMap[key] = {
            daysOfWeek: [],
            startTime,
            endTime,
          };
        }

        if (!slotMap[key].daysOfWeek.includes(day)) {
          slotMap[key].daysOfWeek.push(day);
        }
      });

      const finalArray = Object.values(slotMap);

      setBusinessHours(finalArray);
    }
  }, [availability]);

  useEffect(() => {
    if (userDetails) {
      const orgId = userDetails?.orgs?.length ? userDetails?.orgs[0]?.id : "";
      if (orgId && !slotTimeDuration) {
        getOrgSetting(orgId);
      }
    }
  }, [userDetails]);
  useEffect(() => {
    if (setting) {
      setSlotTimeDuration(
        setting?.slotTimeDuration ? parseInt(setting?.slotTimeDuration) : null
      );
    }
  }, [setting]);

  useEffect(() => {
    if (
      doctors &&
      doctors?.rows?.length > 0 &&
      userDetails &&
      role === "Doctor"
    ) {
      const findDoctor = doctors?.rows?.find(
        (item) => item.userId === userDetails?.id
      );
      if (findDoctor) {
        setSelectedDoc(findDoctor);
      }
    }
  }, [doctors]);

  useEffect(() => {
    if (selectedDept) {
      getAllPatient(selectedDept.id, AthleteType.TEAM);
    }
  }, [selectedDept]);

  useEffect(() => {
    if (selectedPatient && selectedDept) {
      clearAllCases();
      getAllCases(selectedPatient.id);
    }
  }, [selectedPatient, selectedDept]);

  useEffect(() => {
    if (selectedDoc) {
      setGridAnchorDate(moment());
      if (selectedDoc.userId) {
        getDoctorAvailability(`userId=${selectedDoc.userId}`).then((res) => {});
      }
    }
  }, [selectedDoc]);

  const getBreadcrumbData = (urlPath) => {
    switch (urlPath) {
      case APP_URLS.APPOINTMENTS_ADD: {
        return breadCrumbDataForAddAppointmentForm;
      }
      default: {
        return [];
      }
    }
  };

  // The open appointment, resolved from the fetched list so the cancel dialog
  // can show who/when and so an already-cancelled row hides the trash icon.
  const activeAppointment = (appointments || []).find(
    (a) => a.id === selectedAppointmentId
  );
  const isSelectedCancelled = (activeAppointment?.status || "")
    .toUpperCase()
    .startsWith("CANCEL");

  // Cancelling requires a reason, so the trash icon opens the reason dialog
  // instead of cancelling straight away.
  const onRemove = () => {
    setOpenCancelAppointment(true);
  };

  // Only the code and the note are sent: the server resolves the wording the
  // patient sees from the code, and derives cancelledBy from the token, so
  // neither can be spoofed from here.
  const onConfirmCancel = ({ reasonCode, reasonNote }) => {
    setCancellingAppointment(true);
    cancelAppointment(selectedAppointmentId, {
      cancellationReasonCode: reasonCode,
      cancellationNote: reasonNote || "",
    })
      .then(() => {
        setOpenCancelAppointment(false);
        setOpenForm(false);
        if (selectedDoc) {
          const params = { userId: selectedDoc.userId };
          return getAllAppointments(params);
        }
        return null;
      })
      .catch(() => {})
      .finally(() => setCancellingAppointment(false));
  };

  const calculateDayDifference = (selectedDateStr) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayStartTimestamp = today.getTime();

    const selectedDate = new Date(selectedDateStr);
    selectedDate.setHours(0, 0, 0, 0);
    const diffTime = selectedDate.getTime() - todayStartTimestamp;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays;
  };

  const addDaysToDate = (dateStr, daysToAdd) => {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + daysToAdd);
    return date.getTime();
  };

  const mergeDateAndTime = (dateMs, timeMs) => {
    if (!dateMs || !timeMs) return null;
    const date = new Date(dateMs);
    const time = new Date(timeMs);
    date.setHours(time.getHours(), time.getMinutes(), 0, 0);
    return date.getTime();
  };

  const onAdd = async (e) => {
    e.preventDefault();
    const data = {
      appointmentDate: selectedDate,
      startTime: mergeDateAndTime(selectedDate, selectedStartTime),
      endTime: mergeDateAndTime(selectedDate, selectedEndTime),
      title: selectedTitle,
      patientId: selectedPatient?.id,
      userId: selectedDoc?.userId,
      caseId: selectedCase?.id,
      teamId: selectedDept?.id,
      appointmentLink: selectedAppointmentLink || "",
      appointmentType: selectedAppointmentType || "offline",
    };

    try {
      if (selectedAppointmentId) {
        await editAppointment(selectedAppointmentId, data);
        if (data.caseId) {
          const updatedCase = await getSingleCase(data.caseId);
          if (updatedCase) {
            setSelectedCase(updatedCase);
          }
        }
      } else {
        addAppointment(data);
      }
      setOpenForm(false);
      setSelectedDate(null);
      setSelectedDept(null);
      setSelectedPatient(null);
      setSelectedCase(null);
      setSelectedTitle(null);
      setSelectedStartTime(null);
      setSelectedEndTime(null);
      setSelectedAppointmentType(null);

      if (selectedDoc) {
        const params = { userId: selectedDoc.userId };
        getAllAppointments(params).then((res) => {});
      }
    } catch (error) {
      console.error("Error handling appointment:", error);
    }
  };

  const handleCancel = () => {
    history.goBack();
  };

  const handleDateClick = (arg) => {
    const startTime = new Date(arg.dateStr);
    const dateOnly = arg.dateStr.split("T")[0];

    const millisecondsSelectedDate = new Date(dateOnly).getTime();
    const endTime = new Date(startTime);

    endTime.setMinutes(
      endTime.getMinutes() +
        (slotTimeDuration || APPOINTMENT_SCHEDULE_TIME_MINUTES)
    );

    // Convert to UTC Hours and Minutes
    const formattedStartTime = startTime.toISOString().substring(11, 16); // "HH:MM"
    const formattedEndTime = endTime.toISOString().substring(11, 16); // "HH:MM"

    // Convert to Milliseconds Using UTC
    const [startHours, startMinutes] = formattedStartTime
      .split(":")
      .map(Number);
    const startTimeInMillis = new Date().setUTCHours(
      startHours,
      startMinutes,
      0,
      0
    );

    const [endHours, endMinutes] = formattedEndTime.split(":").map(Number);
    const endTimeInMillis = new Date().setUTCHours(endHours, endMinutes, 0, 0);
    const newStartDate = addDaysToDate(
      startTimeInMillis,
      calculateDayDifference(selectedDate)
    );
    const newEndDate = addDaysToDate(
      endTimeInMillis,
      calculateDayDifference(selectedDate)
    );

    if (!isWithinBusinessHours(new Date(newStartDate), new Date(newEndDate))) {
      return;
    }
    setSelectedAppointmentId(null);
    setSelectedDate(millisecondsSelectedDate);
    setSelectedStartTime(startTimeInMillis);
    setSelectedEndTime(endTimeInMillis);
    setSelectedDept(null);
    setSelectedPatient(null);
    setSelectedCase(null);
    setSelectedTitle(null);
    setSelectedAppointmentLink(null);
    setOpenForm(true);
    setSelectedAppointmentType(null);
  };

  useEffect(() => {
    getAllOrgs().then((res) => {});
  }, [getAllOrgs]);

  useEffect(() => {
    getAllDepts().then((res) => {});
  }, [getAllDepts]);

  useEffect(() => {
    getAllDoctors().then((res) => {});
  }, [getAllDoctors]);

  useEffect(() => {
    if (selectedDept) {
      getAllPatient(selectedDept.id, AthleteType.TEAM).then((res) => {});
    }
  }, [getAllPatient, selectedDept]);

  useEffect(() => {
    if (selectedDept && selectedPatient) {
      getAllCases(selectedPatient.id).then((res) => {});
    }
  }, [getAllCases, selectedDept, selectedPatient]);

  useEffect(() => {
    if (selectedDoc) {
      const params = {
        userId: selectedDoc.userId,
      };
      getAllAppointments(params).then((res) => {});
    }
  }, [getAllAppointments, selectedDoc]);

  const patientOptions =
    patients && patients.rows ? [...patients.rows, { id: -1 }] : [{ id: -1 }];

  const caseOptions =
    cases && cases.rows ? [...cases.rows, { id: -1 }] : [{ id: -1 }];

  const handlePatientSelection = (e, value) => {
    setSelectedCase(null);
    if (value && value.id === -1) {
      setOpenCreatePatientModal(true);
    } else {
      setSelectedPatient(value);
    }
  };
  const handleCaseSelection = (e, value) => {
    if (value && value.id === -1) {
      setOpenCreateCaseModal(true);
    } else {
      setSelectedCase(value);
    }
  };

  const handleTimeChange = (event, setTime, selectedDate) => {
    const timeString = event.target.value;
    if (timeString && selectedDate) {
      const [hours, minutes] = timeString.split(":").map(Number);
      const updatedDate = new Date(selectedDate);
      updatedDate.setHours(hours, minutes, 0, 0);
      setTime(updatedDate.getTime());
    }
  };

  const isWithinBusinessHours = (start, end) => {
    const day = start.getDay(); // 0 = Sunday, 1 = Monday...
    const startTime = start.toTimeString().slice(0, 5); // "HH:MM"
    const endTime = end.toTimeString().slice(0, 5); // "HH:MM"

    return businessHours.some((block) => {
      if (!block.daysOfWeek.includes(day)) return false;

      return startTime >= block.startTime && endTime <= block.endTime;
    });
  };

  return (
    <Box className={classes.outerContainer}>
      <AppBreadCrumb>
        {getBreadcrumbData(currentUrlPath).map((crumb, index) => (
          <Box
            key={index}
            component={NavLink}
            exact
            to={{
              pathname: crumb.path,
              state: {},
            }}
            className={classes.breadcrumbItem}
            activeClassName={classes.activeBreadcrumbItem}
          >
            {crumb.icon && (
              <Icon className={classes.breadcrumpIcon}>{crumb.icon}</Icon>
            )}
            <Box className={classes.breadcrumpLabel}>{crumb.name}</Box>
          </Box>
        ))}
      </AppBreadCrumb>

      <Box mt={2}>
        <Box>
          <Box
            component={Paper}
            className={classes.addAppointmentFormContainer}
          >
            <Grid container spacing={2}>
              {role !== "Doctor" && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Autocomplete
                    fullWidth
                    size="small"
                    value={selectedDoc}
                    onChange={async (e, value) => {
                      setSelectedDoc(value);

                      const id = value?.userId || value?.id;

                      if (id) {
                        try {
                          const res = await getUserByIdRequest(id);

                          const doctor = res;

                          if (
                            Array.isArray(doctor.teams) &&
                            doctor.teams.length > 0
                          ) {
                            const depts = doctor.teams.map((team) => ({
                              id: team.team_id,
                              name: team.team_name,
                            }));
                            setFilteredDepts(depts);
                          } else {
                            setFilteredDepts([]);
                          }
                        } catch (err) {
                          setFilteredDepts([]);
                        }
                      }
                    }}
                    options={
                      doctors && doctors.rows
                        ? doctors.rows?.filter((item) => item.role === "Doctor")
                        : []
                    }
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option, value) => {
                      if (option && value) {
                        return option.id === value.id;
                      } else {
                        return true;
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Doctor *"
                        variant="outlined"
                      />
                    )}
                    validators={["required"]}
                    errorMessages={["Doctor is required"]}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {selectedDoc && (
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={8} lg={9}>
                      <WeeklyScheduleGrid
                        appointments={appointments || []}
                        workingHours={availability}
                        viewMode={gridViewMode}
                        anchorDate={gridAnchorDate}
                        onPrev={() =>
                          setGridAnchorDate((prev) =>
                            prev
                              .clone()
                              .subtract(
                                1,
                                gridViewMode === "week" ? "week" : "day"
                              )
                          )
                        }
                        onNext={() =>
                          setGridAnchorDate((prev) =>
                            prev
                              .clone()
                              .add(1, gridViewMode === "week" ? "week" : "day")
                          )
                        }
                        onViewChange={setGridViewMode}
                        onChipClick={(appt) =>
                          handleEventClick({
                            event: {
                              id: appt.id,
                              start: appt.startTime,
                              end: appt.endTime,
                            },
                          })
                        }
                        onDayHeaderClick={(day) => {
                          setSidebarDate(day.clone());
                          if (day.month() !== sidebarCalMonth.month()) {
                            setSidebarCalMonth(day.clone().startOf("month"));
                          }
                        }}
                        onEmptyClick={(day, h, m) => {
                          const slot = day
                            .clone()
                            .hour(h)
                            .minute(m)
                            .second(0)
                            .millisecond(0);
                          // ignore past slots
                          if (slot.isBefore(moment())) return;
                          handleDateClick({
                            dateStr: slot.format("YYYY-MM-DDTHH:mm:ss"),
                          });
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                      <SelectedDaySidebar
                        appointments={appointments || []}
                        selectedDate={sidebarDate}
                        setSelectedDate={setSidebarDate}
                        calMonth={sidebarCalMonth}
                        setCalMonth={setSidebarCalMonth}
                        onCardClick={(appt) =>
                          handleEventClick({
                            event: {
                              id: appt.id,
                              start: appt.startTime,
                              end: appt.endTime,
                            },
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Dialog
                open={openForm}
                onClose={() => setOpenForm(false)}
                maxWidth="xs"
                fullWidth
                classes={{ paper: classes.dialogPaper }}
              >
                <ValidatorForm ref={formRef} onSubmit={onAdd}>
                  <Box className={classes.dialogHeader}>
                    <Box className={classes.dialogHeaderLeft}>
                      <Box className={classes.dialogHeaderIcon}>
                        <EventNoteRoundedIcon style={{ fontSize: 22 }} />
                      </Box>
                      <Box>
                        <Typography className={classes.dialogTitleText}>
                          {formMode === "readonly"
                            ? "View Appointment"
                            : "Schedule Appointment"}
                        </Typography>
                        <Typography className={classes.dialogDate}>
                          {moment(selectedDate).format("DD MMM YYYY")}
                        </Typography>
                      </Box>
                    </Box>
                    {formMode === "editable" &&
                      selectedAppointmentId &&
                      !isSelectedCancelled && (
                        <Button
                          className={classes.deleteBtn}
                          onClick={onRemove}
                          aria-label="cancel appointment"
                        >
                          <RemoveIcon />
                        </Button>
                      )}
                  </Box>
                  <DialogContent className={classes.appointmentModal}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                          fullWidth
                          label="Title *"
                          size="small"
                          variant="outlined"
                          value={selectedTitle}
                          onChange={(e) => setSelectedTitle(e.target.value)}
                          validators={["required"]}
                          errorMessages={["Title is required"]}
                          disabled={formMode === "readonly"}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <AutocompleteValidator
                          fullWidth
                          size="small"
                          value={selectedDept}
                          onChange={(e, value) => {
                            setSelectedDept(value);
                          }}
                          options={filteredDepts}
                          getOptionLabel={(option) => option.name}
                          getOptionSelected={(option, value) => {
                            if (option && value) {
                              return option.id === value.id;
                            } else {
                              return true;
                            }
                          }}
                          renderInput={(params) => (
                            <TextValidator
                              {...params}
                              label="Department *"
                              variant="outlined"
                            />
                          )}
                          validators={["required"]}
                          errorMessages={["Department is required"]}
                          disabled={formMode === "readonly"}
                        />
                      </Grid>
                      {selectedDept && (
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <AutocompleteValidator
                            fullWidth
                            size="small"
                            options={patientOptions}
                            value={selectedPatient}
                            onChange={handlePatientSelection}
                            getOptionLabel={(option) => {
                              if (option.inputValue) return option.inputValue;
                              if (option.id !== -1)
                                return `${option.firstName} ${option.lastName}`;
                              return "";
                            }}
                            filterOptions={(options, params) => {
                              const input = params.inputValue.toLowerCase();

                              const filtered = options.filter((option) => {
                                const fullName =
                                  `${option.firstName} ${option.lastName}`.toLowerCase();
                                const mobile =
                                  option.mobile?.toLowerCase() || "";
                                return (
                                  fullName.includes(input) ||
                                  mobile.includes(input)
                                );
                              });

                              // If no match and input value exists, add "Add Patient" option
                              if (input !== "" && filtered.length === 0) {
                                filtered.push({
                                  id: -1,
                                  inputValue: params.inputValue,
                                  firstName: "",
                                  lastName: "",
                                  mobile: "",
                                  imageUrl: "",
                                });
                              }

                              return filtered;
                            }}
                            renderOption={(option) => {
                              if (option.id !== -1) {
                                return (
                                  <Box className={classes.optionsContainer}>
                                    <Box className={classes.optionAvatar}>
                                      <img
                                        alt="profile"
                                        src={
                                          option.imageUrl
                                            ? option.imageUrl
                                            : defaultUser
                                        }
                                        className={classes.optionAvatarImage}
                                      />
                                    </Box>
                                    <Box
                                      className={classes.optionNameContainer}
                                    >
                                      {option.firstName} {option.lastName} (
                                      {option.mobile})
                                    </Box>
                                  </Box>
                                );
                              } else {
                                return (
                                  <Box className={classes.addOption}>
                                    ➕ Add Patient
                                  </Box>
                                );
                              }
                            }}
                            renderInput={(params) => (
                              <TextValidator
                                {...params}
                                label="Patient *"
                                variant="outlined"
                              />
                            )}
                            validators={["required"]}
                            errorMessages={["Patient is required"]}
                            disabled={formMode === "readonly"}
                          />
                        </Grid>
                      )}
                      {selectedPatient && (
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <AutocompleteValidator
                            fullWidth
                            size="small"
                            options={caseOptions}
                            value={selectedCase}
                            onChange={handleCaseSelection}
                            getOptionSelected={(option, value) =>
                              option.id === value.id
                            }
                            getOptionLabel={(option) => {
                              if (option.id !== -1) {
                                return `${option.desc}`;
                              } else {
                                return "";
                              }
                            }}
                            disabled={formMode === "readonly"}
                            renderOption={(option) => {
                              if (option.id !== -1) {
                                return (
                                  <Box className={classes.optionsContainer}>
                                    <Box
                                      className={classes.optionNameContainer}
                                    >
                                      {option.desc}
                                    </Box>
                                  </Box>
                                );
                              } else {
                                return (
                                  <Box className={classes.addOption}>
                                    Add Case
                                  </Box>
                                );
                              }
                            }}
                            renderInput={(params) => (
                              <TextValidator
                                {...params}
                                label="Case *"
                                variant="outlined"
                              />
                            )}
                            validators={["required"]}
                            errorMessages={["Case is required"]}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                          fullWidth
                          type="time"
                          label="Start Time *"
                          placeholder="Start Time"
                          size="small"
                          value={formatTime(selectedStartTime)}
                          variant="outlined"
                          onChange={(e) =>
                            handleTimeChange(
                              e,
                              setSelectedStartTime,
                              selectedDate
                            )
                          }
                          validators={["required"]}
                          errorMessages={["Start Time is required"]}
                          disabled={formMode === "readonly"}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                          fullWidth
                          type="time"
                          label="End Time *"
                          size="small"
                          value={formatTime(selectedEndTime)}
                          variant="outlined"
                          onChange={(e) =>
                            handleTimeChange(
                              e,
                              setSelectedEndTime,
                              selectedDate
                            )
                          }
                          validators={["required"]}
                          errorMessages={["End Time is required"]}
                          disabled={formMode === "readonly"}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <SelectValidator
                          fullWidth
                          label="Appointment Type *"
                          name="appointmentType"
                          size="small"
                          variant="outlined"
                          value={selectedAppointmentType}
                          onChange={(e) =>
                            setSelectedAppointmentType(e.target.value)
                          }
                          validators={["required"]}
                          errorMessages={["Appointment Type is required"]}
                          disabled={formMode === "readonly"}
                        >
                          <MenuItem value="online">Online</MenuItem>
                          <MenuItem value="offline">Offline</MenuItem>
                        </SelectValidator>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextValidator
                          fullWidth
                          label="Appointment Link"
                          size="small"
                          variant="outlined"
                          value={selectedAppointmentLink}
                          onChange={(e) =>
                            setSelectedAppointmentLink(e.target.value)
                          }
                          disabled={formMode === "readonly"}
                          placeholder={
                            selectedAppointmentType === "online"
                              ? "Leave empty for an automatic Google Meet link"
                              : ""
                          }
                          helperText={
                            selectedAppointmentType === "online"
                              ? "Leave empty and a Google Meet link is created automatically once the booking is confirmed, with the doctor as host. Enter a link only to use a different meeting."
                              : ""
                          }
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions className={classes.dialogActionsBar}>
                    <Button
                      onClick={() => setOpenForm(false)}
                      className={classes.cancelBtn}
                    >
                      Cancel
                    </Button>
                    {formMode === "editable" && (
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disableElevation={true}
                        className={classes.saveBtn}
                      >
                        Save
                      </Button>
                    )}
                  </DialogActions>
                </ValidatorForm>
              </Dialog>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Box>
        <AddPatient
          openCreateAthleteModal={openCreatePatientModal}
          setOpenCreateAthleteModal={setOpenCreatePatientModal}
          setSelectedAthlete={setSelectedPatient}
          selectedDepartment={selectedDept}
        />
      </Box>
      <Box>
        <ConfirmationDialog
          open={openCancelConfirmation}
          setOpen={setOpenCancelConfirmation}
          title="Cancel"
          message="Are you sure you want to cancel?"
          onConfirm={handleCancel}
        />
      </Box>
      <Box>
        <CancelAppointmentDialog
          open={openCancelAppointment}
          appointment={activeAppointment}
          submitting={cancellingAppointment}
          onClose={() => setOpenCancelAppointment(false)}
          onConfirm={onConfirmCancel}
        />
      </Box>
      <Box>
        <AddCaseDialog
          openCreateCaseModal={openCreateCaseModal}
          setOpenCreateCaseModal={setOpenCreateCaseModal}
          selectedDept={selectedDept}
          selectedPatient={selectedPatient}
          setSelectedCase={setSelectedCase}
          selectedDoc={selectedDoc}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    departmentData: state.departments.depts,
    orgs: state.organisations.orgs,
    doctors: state.doctors.doctors,
    patients: state.athletes.athletes,
    cases: state.athletes.cases,
    appointments: state.appointments.appointments,
    availability: state.departments.availability,
    setting: state.organisations.setting,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDoctorAvailability: (id) => {
      return dispatch(getAvailabilityRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getOrgSetting: (orgId) => {
      return dispatch(getSettingRequest(orgId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    addAppointment: (data) => {
      return dispatch(addAppointmentRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    editAppointment: (id, data) => {
      return dispatch(editAppointmentRequest(id, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    cancelAppointment: (id, data) => {
      return dispatch(cancelAppointmentRequest(id, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getAllAppointments: (params) => {
      return dispatch(getDoctorAppointmentRequest(params)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getAllDepts: () => {
      return dispatch(getAllDeptsRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getAllDoctors: () => {
      return dispatch(getDoctorsRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getAllOrgs: () => {
      return dispatch(getOrganisationsWithoutParamsRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    getAllPatient: (id, type) => {
      return dispatch(getPatientsWithoutParamsRequest(id, type)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getUserByIdRequest: (id) => {
      return dispatch(getUserByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getAllCases: (id) => {
      return dispatch(getPatientCasesRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getSingleCase: (id) => {
      return dispatch(getCaseByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },

    clearAllCases: () => {
      return dispatch(clearCases());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentForm);
